import React, { useEffect, useState } from "react";
import styles from "./SimpleToast.module.css";

interface Props {
  timeoutMs?: number;
  message: string;
}

// TODO: Possibility to pass timer as prop, or have exit button
export const SimpleToast: React.FC<React.PropsWithChildren<Props>> = ({
  message,
  timeoutMs,
}) => {
  const [showToast, setToast] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setToast(false);
    }, timeoutMs ?? 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (showToast) {
    return <div className={styles.toaster}>{message}</div>;
  }
  return null;

  // return null;
};
